const liveViewTracks = new WeakSet();
export const MIN_LIVE_VIEW_FPS = 25;
export const MAX_LIVE_VIEW_FPS = 45;
export function registerLiveViewStream(stream) {
    for (const track of stream.getVideoTracks()) {
        liveViewTracks.add(track);
    }
}
export function preserveLiveViewResolution(track, parameters, requested) {
    var _a, _b;
    if (track === null || !liveViewTracks.has(track))
        return false;
    parameters.degradationPreference = "maintain-resolution";
    if (parameters.encodings.length === 0)
        parameters.encodings = [{}];
    for (const encoding of parameters.encodings) {
        encoding.scaleResolutionDownBy = 1;
        // Translate the webcam bandwidth controller's spatial reductions into temporal reductions.
        if ((requested === null || requested === void 0 ? void 0 : requested.scaleResolutionDownBy) !== undefined) {
            const scale = Math.max(1, requested.scaleResolutionDownBy);
            encoding.maxFramerate = Math.min((_a = requested.maxFramerate) !== null && _a !== void 0 ? _a : MAX_LIVE_VIEW_FPS, Math.max(MIN_LIVE_VIEW_FPS, Math.floor(MAX_LIVE_VIEW_FPS / (scale * scale))));
        }
        else {
            encoding.maxFramerate = Math.min((_b = encoding.maxFramerate) !== null && _b !== void 0 ? _b : MAX_LIVE_VIEW_FPS, MAX_LIVE_VIEW_FPS);
        }
    }
    return true;
}
